import { render, staticRenderFns } from "./InsertPromotion.vue?vue&type=template&id=6fdd0f3a&scoped=true"
import script from "./InsertPromotion.vue?vue&type=script&lang=js"
export * from "./InsertPromotion.vue?vue&type=script&lang=js"
import style0 from "./InsertPromotion.vue?vue&type=style&index=0&id=6fdd0f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../컨셉펀딩/worktrees/yesandlegeyo-copy-test-20260921/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdd0f3a",
  null
  
)

export default component.exports